import { ComboItem } from "../../../../model";
import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { ISociedad } from "../model";

export default class SociedadService extends ServiceBase {
  get = (data:{ user?: string, id?: number }) : Promise<IResponse<ISociedad>> => 
    this.GetFetch<IResponse<ISociedad>>('entity/sociedad', data);

  combo = (data: { activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<IResponse<ComboItem[]>>('entity/sociedad/combo', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, codigo?: string, nombre?: string, activo?: boolean }) : Promise<IPaginatedResponse<ISociedad>> => 
    this.GetFetch<IPaginatedResponse<ISociedad>>('entity/sociedad/find', data);

  all = () : Promise<IResponse<ISociedad[]>> => 
    this.GetFetch<IResponse<ISociedad[]>>('entity/sociedad/all', {});

  upsert = (data:ISociedad) : Promise<IResponse<ISociedad>> => 
    this.PostFetch<IResponse<ISociedad>>('entity/sociedad', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/sociedad', data);  
}
